export { default } from './svg/facebook-round.svg';
